var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3207 7.08317C22.7044 7.35314 23.9761 8.02987 24.973 9.02675C25.9698 10.0236 26.6466 11.2953 26.9165 12.679M21.3207 1.4165C24.1955 1.73587 26.8763 3.02325 28.9229 5.06726C30.9695 7.11128 32.2602 9.79043 32.5832 12.6648M31.1665 23.9698V28.2198C31.1681 28.6144 31.0873 29.0049 30.9293 29.3664C30.7712 29.7279 30.5394 30.0524 30.2486 30.3191C29.9579 30.5859 29.6147 30.7889 29.2409 30.9153C28.8672 31.0417 28.4711 31.0887 28.0782 31.0532C23.7189 30.5795 19.5314 29.0899 15.8524 26.704C12.4295 24.5289 9.52742 21.6269 7.35237 18.204C4.95817 14.5082 3.46821 10.3004 3.0032 5.9215C2.9678 5.52975 3.01435 5.13491 3.13991 4.76214C3.26546 4.38936 3.46726 4.04681 3.73245 3.7563C3.99764 3.46579 4.32042 3.23368 4.68024 3.07474C5.04005 2.91581 5.42901 2.83354 5.82237 2.83317H10.0724C10.7599 2.8264 11.4264 3.06987 11.9477 3.51818C12.469 3.96649 12.8095 4.58905 12.9057 5.26984C13.0851 6.62993 13.4178 7.96537 13.8974 9.25067C14.088 9.75773 14.1292 10.3088 14.0162 10.8386C13.9032 11.3684 13.6408 11.8547 13.2599 12.2398L11.4607 14.039C13.4774 17.5857 16.414 20.5223 19.9607 22.539L21.7599 20.7398C22.145 20.3589 22.6313 20.0965 23.1611 19.9835C23.6909 19.8705 24.242 19.9117 24.749 20.1023C26.0343 20.5819 27.3698 20.9146 28.7299 21.094C29.418 21.1911 30.0465 21.5377 30.4958 22.068C30.9451 22.5982 31.1838 23.2751 31.1665 23.9698Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d0feee6275b0662d4b2a8cb1b9e82c83.svg";
export { ForwardRef as ReactComponent };